import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  tax: {
    tax1: {},
    tax2: {},
  },
  priceLevel: {},
};

const SliceGRN = createSlice({
  name: "SliceGRN",
  initialState: { value: initialState },

  reducers: {
    GrnTax_Set: (state, action) => {
      state.value.tax = action.payload;
    },
    PriceLevel_Set: (state, action) => {
      state.value.priceLevel = action.payload;
    },
    GrnTax_Init: (state) => {
      state.value = initialState;
    },
    // GrnTax_SetValue: (state, action) => {
    //   state.value = action.payload;
    // },
  },
});

export const { GrnTax_Set, GrnTax_Init, PriceLevel_Set } = SliceGRN.actions;
export default SliceGRN.reducer;
